import React, { useState, useEffect, useMemo } from "react";
import { Formik, Form, FormikHelpers } from "formik";
import * as Yup from "yup";

//MUI
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import FormikControl from "../../components/formik/FormikControl";
import Loader from "../../components/loader/Loader";

import CustomerService from "../../services/CustomerService";
import { Mode } from "./CustomerPage";
import { CustomerModel } from "../../models/CustomerModel";
// import { statusOptions } from "../../utility/utils";
import { fetchCustomers } from "../../redux/actions/CustomerActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { createAutocompleteOptions } from "../../utility/utils";

const validationSchema = Yup.object({
  name: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
  customerType: Yup.number().min(1, "Required").required("Required"),
  // status: Yup.string().required("Required"),
});

type FormProps = Yup.InferType<typeof validationSchema>;

type Props = {
  mode: Mode;
  handleModalClose: () => void;
  data?: CustomerModel;
};

const CustomerForm = ({ mode, handleModalClose, data }: Props) => {
  const initialValues = useMemo(
    () => ({
      name: "",
      description: "",
      customerType: 0,
      // status: "",
    }),
    []
  );

  const [formState, setFormState] = useState<FormProps>(initialValues);
  const dispatch = useAppDispatch();
  const displayToast = useAppSelector((state) => state.toast.displayToast);

  const customerTypes = useAppSelector(
    (state) => state.customerType.all_CustomerTypes
  );

  const customerTypeOptions = useMemo(() => {
    return createAutocompleteOptions(customerTypes, "customerTypeId", "name");
  }, [customerTypes]);

  useEffect(() => {
    if (mode === "edit" && data) {
      setFormState(() => ({
        name: data.name,
        description: data.description,
        customerType: data.customerTypeId,
        // status: data.isActive ? "active" : "inactive",
      }));
    }
  }, [mode, data]);

  const submitHandler = async (
    values: FormProps,
    actions: FormikHelpers<FormProps>
  ) => {
    try {
      let formData: CustomerModel = {
        customerId: 0,
        name: "",
        description: "",
        customerTypeId: 0,
        isActive: true,
        createdDate: new Date(),
        modifiedDate: new Date(),
      };
      if (mode === "add") {
        formData.name = values.name;
        formData.description = values.description;
        formData.customerTypeId = values.customerType;
        // formData.isActive = values.status === "active" ? true : false;
      } else if (data) {
        formData = {
          ...data,
          name: values.name,
          description: values.description,
          customerTypeId: values.customerType,
          // isActive: values.status === "active" ? true : false,
          modifiedDate: new Date(),
        };
      }
      await CustomerService.createCustomer(formData, data?.customerId);
      actions.setSubmitting(false);
      handleModalClose();
      dispatch(fetchCustomers());
      displayToast(
        `Customer ${mode === "add" ? "created" : "updated"} successfully`,
        "success"
      );
    } catch (error) {
      actions.setSubmitting(false);
    }
  };
  return (
    <Formik
      initialValues={formState}
      validationSchema={validationSchema}
      onSubmit={submitHandler}
      enableReinitialize={true}
    >
      {(formik) => (
        <>
          <Form>
            <Stack gap={2}>
              <FormikControl
                control="input"
                type="text"
                name="name"
                size="small"
                label="Name"
                placeholder="Enter Name"
              />
              <FormikControl
                control="input"
                multiline
                maxRows={2}
                name="description"
                size="small"
                label="Description"
                placeholder="Enter Description"
              />
              <FormikControl
                control="autocomplete"
                options={customerTypeOptions}
                name="customerType"
                size="small"
                label="Customer Type"
                placeholder="Select Customer Type"
              />
              {/* <FormikControl
                control="autocomplete"
                options={statusOptions}
                name="status"
                size="small"
                label="Status"
                placeholder="Select Status"
              /> */}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={formik.isSubmitting}
              >
                Submit
              </Button>
            </Stack>
          </Form>
          {formik.isSubmitting && <Loader />}
        </>
      )}
    </Formik>
  );
};

export default CustomerForm;
